'use client';

import { useDepthPin } from './depthPin';
import { inputFocusTop } from './inputFocusTop';
import { RevealDepth, useRevealDepth } from './revealDepth';
import { scrollToListTop } from './scrollToListTop';

interface UseLpScrollParams {
  /** 현재 그려진 뎁스 행 수. 바뀌면 높이를 다시 잰다 */
  rowCount: number;
}

interface UseLpScrollReturn {
  /** 목록 최상단으로 스크롤한다. 이동했으면 목표 위치를, 아니면 null을 반환한다 */
  scrollToListTop: () => number | null;
  /** 뎁스 상태 변경(apply)을 스크롤 이동이 끝나갈 즈음 등장 모션과 함께 반영한다 */
  revealDepth: RevealDepth;
  /** 검색 인풋 onFocus 핸들러. 키보드가 올라온 뒤 목록 상단을 맞춘다 */
  inputFocusTop: () => void;
}

/**
 * 상품 목록 페이지(LP) 상단 영역(검색창·카테고리 탭·필터 바) 스크롤 동작 훅
 *
 * - 스크롤 시 카테고리 탭 고정과 상위 뎁스 접힘/펼침 — 훅 호출만으로 자동
 * - 뎁스 변경 시 최상단 이동과 하위 뎁스 등장 모션 — scrollToListTop + revealDepth
 * - 검색 인풋 포커스 시 목록 상단 맞춤 — inputFocusTop
 *
 * 전제 마크업·스타일과 적용 예시는 같은 폴더의 README.md 참고.
 */
export function useLpScroll({
  rowCount,
}: UseLpScrollParams): UseLpScrollReturn {
  useDepthPin(rowCount);
  const revealDepth = useRevealDepth();

  return { scrollToListTop, revealDepth, inputFocusTop };
}
